import { useMediaQuery } from '@material-ui/core';
import PELogo from '@pe-libs/react-components/build/assets/common/logos/logo.svg';
import PeImage from '@pe-libs/react-components/build/components/PeImage';
import PeLink from '@pe-libs/react-components/build/components/PeLink';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import { useTheme } from '@pe-libs/react-components/build/theme';
import React from 'react';
import { useSelector } from 'react-redux';
import LanguageSwitch from '#components/languageSwitch';
import { getUserLocale } from '#modules/app/selectors';
import messages from './messages';
import useStyles from './styles';

const Header = () => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const theme = useTheme();
  const locale = useSelector(getUserLocale)?.toLowerCase() ?? 'de-de';
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <div className={styles.header}>
      <PeLink className={styles.PELogo} href={`/${locale}`} title={formatMessage(messages.hoverPELogo)}>
        <PeImage
          alt={formatMessage(messages.hoverPELogo)}
          src={PELogo as string}
          layout="fixed"
          width={189}
          height={56}
        />
      </PeLink>
      <LanguageSwitch isHoverable={isDesktop} />
    </div>
  );
};

export default Header;
